import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  width: 100%;
`;

const BackLink = styled.button`
  display: block;
  margin: 0 auto 1.5rem;
  background: none;
  border: none;
  color: #666;
  font-size: 0.9rem;
  text-decoration: underline;

  &:hover {
    color: #e91e63;
  }
`;

const Title = styled.h2`
  color: #e91e63;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const Subtitle = styled.p`
  color: #666;
  text-align: center;
  margin-bottom: 2.5rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  max-width: 520px;
  margin: 0 auto;
`;

const OptionButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  gap: 0.45rem;
  padding: 1.1rem 1.15rem;
  border-radius: 8px;
  border: 1px solid #e91e63;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    background-color: #fff5f8;
  }
`;

const OptionTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
`;

const OptionName = styled.span`
  font-weight: 600;
  font-size: 1.05rem;
  color: #e91e63;
`;

const Stars = styled.span`
  flex-shrink: 0;
  font-size: 0.9rem;
  letter-spacing: 0.06em;
  white-space: nowrap;
`;

const FilledStar = styled.span`
  color: #e6a817;
`;

const EmptyStar = styled.span`
  color: #ddd;
`;

const AnyLevel = styled.span`
  flex-shrink: 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: #999;
`;

const OptionDescription = styled.span`
  font-size: 0.85rem;
  line-height: 1.35;
  color: #666;
`;

// Each tier faces you against a random personality of that difficulty; "Random"
// draws from all of them. Stars mirror the personality-page legend.
const OPTIONS = [
  { level: 'Easy', stars: 1, blurb: 'A warm, easygoing date who keeps the conversation flowing.' },
  { level: 'Medium', stars: 2, blurb: 'A date who takes a bit more effort to win over.' },
  { level: 'Hard', stars: 3, blurb: 'A guarded, hard-to-read date. Only your best game lands this one.' },
  { level: 'Random', blurb: "A completely random personality — you won't know who you're facing until you start." },
];

const renderStars = (count) =>
  Array.from({ length: 3 }, (_, i) =>
    i < count ? <FilledStar key={i}>★</FilledStar> : <EmptyStar key={i}>★</EmptyStar>
  );

const DifficultySelection = ({ onSelectDifficulty, onBack }) => (
  <Container>
    {onBack && <BackLink onClick={onBack}>&larr; Back to modes</BackLink>}
    <Title>Date in Eight</Title>
    <Subtitle>Choose your challenge — how tough a date do you want to win over?</Subtitle>
    <Grid>
      {OPTIONS.map((option) => (
        <OptionButton key={option.level} onClick={() => onSelectDifficulty(option.level)}>
          <OptionTitleRow>
            <OptionName>{option.level === 'Random' ? 'Surprise Me' : option.level}</OptionName>
            {option.level === 'Random' ? (
              <AnyLevel>Any level</AnyLevel>
            ) : (
              <Stars aria-label={`${option.level} difficulty`}>{renderStars(option.stars)}</Stars>
            )}
          </OptionTitleRow>
          <OptionDescription>{option.blurb}</OptionDescription>
        </OptionButton>
      ))}
    </Grid>
  </Container>
);

export default DifficultySelection;
